import { SelectSearchField } from 'components'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'
import SalesDealsApi from 'api/admins/sales-deals-api'


const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
 * Search field to select courier.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
const CourierSelectSearchField = ({
  name,
  label,
  required,
  latitude,
  longitude,
  productIdWithSellingPriceList,
  ...props
}) => {

  const { setFieldError, setFieldTouched, setFieldValue } = useFormikContext()

  const [ courierList, setCourierList ]                       = useState([])
  const [ filteredCourierList, setFilteredCourierList ]       = useState([])
  const [ isSearchLoading, setSearchLoading ] = useState(false)

  // search courier.
  const getCourierList = () => {
    setSearchLoading(true)
    SalesDealsApi.couriers({
      latitude: latitude,
      longitude: longitude,
      product_id_with_selling_price_list: productIdWithSellingPriceList,
    })
    .then((response) => {
      const couriers = response.data.couriers.filter((o) => !!o.rate.id)
      setCourierList(couriers)
      setFilteredCourierByQuery(couriers, '')
    })
    .catch((error) => {
      const couriers = error.response?.data?.couriers?.filter((o) => !!o.rate.id) ?? []
      setCourierList(couriers)
      setFilteredCourierByQuery(couriers, '')
      
      setFieldError(name, error.response.data.message)
      setFieldTouched(name, true, false)
    })
    .finally(() => setSearchLoading(false))
  }

  useEffect(() => {
    getCourierList()
  },[])

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.logistic.name }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.rate.name }</span>
    </>
  )

  // handler to search couriers
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    setFilteredCourierByQuery(courierList, searchText)
  }
  const setFilteredCourierByQuery = (courierList, searchText) => {
    if(searchText){
      setFilteredCourierList(
        courierList.filter(o => o.logistic.name.toLowerCase().includes(searchText) || o.rate.name.toLowerCase().includes(searchText))
      )
    }else{
      setFilteredCourierList(courierList)
    }
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search courier...'
      dataList={ filteredCourierList }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={(selectedOption) => {
        setFieldValue(name, selectedOption)
        setFieldTouched(name, true, false)
      }}
      { ...props }
    />
  )
}

CourierSelectSearchField.propTypes    = propTypes
CourierSelectSearchField.defaultProps = defaultProps

export default CourierSelectSearchField
